export const COLUMNS =[
    {
        Header      : '#',
        accessor    : 'orgCode',
        Cell            : e=><div className="text-center">{e.value}</div>,
        disableFilters:true
    },
    {
        Header      : 'Organization Name',
        accessor    : 'orgName',
    },
    {
        Header      : 'Type of Certification',
        accessor    : 'typeOfCertification',
        disableFilters:true
    },
    {
        Header      : 'Assign',
        accessor    : 'assignlist',
        Cell            : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/surveillanceauditassign/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Observation',
        accessor    : 'observationlist',
        // Cell        : e=><div className="text-center"><a href={'/admin/roi/listroi'}> {'View'} </a></div>,
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/surveillanceobservation/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Plan Matrix',
        accessor    : 'planmatrixlist',
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/auditplanmatrix/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    }, 
    
]